import {
  PopoverWrap
} from "./KENF4KX6.jsx";
import {
  cn
} from "./O62HZC57.jsx";
import {
  Calendar
} from "./HHK3W2CE.jsx";
import {
  useLocalization
} from "./E42DI7CC.jsx";
import {
  IconCalendar
} from "./WHJJ2L4B.jsx";

// src/DatePicker/DatePicker.tsx
import { createSignal, createEffect, splitProps, Show } from "solid-js";
import { debounce } from "lodash-es";
var DATE_REGEX = /^\d{1,2}\/\d{1,2}\/\d{2}(\d{2})?$|^\d{4}[/-]\d{1,2}[/-]\d{1,2}$/;
var parseDate = (date) => {
  if (!date) return void 0;
  const [year, month, day] = date.split(/[-/T\s:]/).map(Number);
  return new Date(year, month - 1, day);
};
var formatDate = (locale, date) => date ? new Intl.DateTimeFormat(locale, {
  year: "numeric",
  month: "2-digit",
  day: "2-digit"
}).format(date) : "";
var DatePicker = (props) => {
  const { t, currentLanguage } = useLocalization();
  const [params, rest] = splitProps(props, ["value", "onChange", "class", "yearRange", "disabledDate", "defaultMonth"]);
  const [date, setDate] = createSignal();
  createEffect(() => setDate(parseDate(params.value)));
  const changeDate = (date2) => {
    const year = date2.getFullYear();
    const month = (date2.getMonth() + 1).toString().padStart(2, "0");
    const day = date2.getDate().toString().padStart(2, "0");
    props.onChange?.(`${year}-${month}-${day}`);
    setDate(date2);
  };
  const handleChange = (e) => {
    e.target.value = e.target.value.replace(/[^0-9/-]/g, "");
    const input = e.target.value;
    if (!input) {
      props.onChange?.(void 0);
      return setDate(void 0);
    }
    if (!DATE_REGEX.test(input)) return;
    const date2 = new Date(input);
    if (isNaN(date2.getTime())) return;
    changeDate(date2);
  };
  const handleDebouncedChange = debounce(handleChange, 500);
  return <PopoverWrap
    class="relative"
    onOutsideClick={(e) => e.currentTarget.contains(e.relatedTarget) && e.preventDefault()}
  >
      {({ setOpen }) => <button
    id={`${props.id}-btn`}
    onClick={(e) => e.preventDefault()}
    tabIndex="-1"
    class={cn(
      "bg-light-gray placeholder:text-auxiliary-text focus-within:ring-essential-colour focus:ring-essential-colour inline-flex w-full origin-[--transform-origin] items-center gap-1 rounded-md border px-3 py-2 pr-[42px] text-sm text-black focus-within:ring-1 focus:ring-1",
      params.class
    )}
  >
          <Show when={props.prefix}>
            <span
    onClick={() => {
      !props.disabled && setOpen((prev) => !prev);
    }}
    class="text-text-level03 select-none whitespace-nowrap"
  >
              {props.prefix}:
            </span>
          </Show>
          <input
    id={`${props.id}-input`}
    autocomplete="off"
    type="tel"
    placeholder={t("MM/DD/YYYY")}
    {...rest}
    value={formatDate(currentLanguage(), date())}
    onFocus={() => setOpen(true)}
    onBlur={(e) => {
      e.target.value = formatDate(currentLanguage(), date());
    }}
    onKeyDown={(e) => {
      if (e.key === "Tab") {
        handleChange({ target: e.target });
        setOpen(false);
      }
    }}
    onInput={handleDebouncedChange}
    class="flex-1 bg-transparent px-1 outline-none"
  />
          <IconCalendar
    class="text-text-level02 absolute inset-y-0 right-0 mx-3 my-2 size-5 cursor-pointer"
    onClick={() => {
      !props.disabled && setOpen((prev) => !prev);
    }}
  />
          <PopoverWrap.Content
    id={`${props.id}-calendar`}
    as={Calendar}
    align="start"
    class="my-1 rounded-md border bg-white"
    selected={date()}
    yearRange={params.yearRange}
    onSelect={(date2) => {
      changeDate(date2);
      setOpen(false);
    }}
    disabledDate={params.disabledDate}
    defaultMonth={params.defaultMonth}
  />
        </button>}
    </PopoverWrap>;
};

export {
  DatePicker
};
